import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper'
import { BasicSelect } from 'vue-search-select';

export default {
  name: 'Pickuploss',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
  },
  mixins: [PageTracker],
  data: function () {
    return {
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      isShowing: false,
      listtype: 'ServiceCenter',
      clientid: 0,
      hubzone: 0,
      hubname: 0,
      notifystatus: 'Pending',
      amount: 0,
      amountcomparator: '',
      netpaymnet: '',
      gapdays: 0,
      gapdayscomparator: '',
      txtgapdays: '',
      clientList: [],
      hubZoneList: [],
      hubServiceCenterList: [],
      shipmentList: [],
      shipmentListCSV: [],
      pageno: 1,
      pagecount: 0,
      clientItemObj: { value: '', label: '' },
      isSearchLoading: false,
      srLoader: "",
      localhubdetails: '',
      defaultHhub: { hubID: '', HubName: '' },
      zone_obj: { hubzoneid: '', hubzonename: '' },
      hubinfo: {},
      totalRecords: 0,
      clientArrayList: [],
      awbnumbers: '',
      Vertical : '',
      value: 0,
      last_value: 0,
      validation: {
        min: 0,
        max: 10000000000000,
        decimal: 100
      },
      userDataKey : '',
      loggedInuserdetails: [],
      isLostNewFeaturesisOnThisHub: '',
      fromDate: null,
      toDate: null,
      dateError: "",
      source: 'Forward PickLoss'
    }
  },
  created: function () {
  },
  filters: {
    flteramount: function(amount) {
      if (amount == null || amount == '' || amount == '0' || amount == 0)
        return '0.00';
      return amount;
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    this.getClientData();
    this.getHubZoneData();
    this.getHubServiceCenterData();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.loggedInuserdetails = userdetail
    // delete this.loggedInuserdetails.department;
    // delete this.loggedInuserdetails.designation;
    // delete this.loggedInuserdetails.jobProfile;
    console.log(" this.loggedInuserdetails ----------->>", this.loggedInuserdetails);
    this.hubinfo = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    this.defaultHhub.hubID = this.hubinfo.HubID
    this.defaultHhub.HubName = this.hubinfo.HubName
    this.zone_obj.hubzoneid = this.hubinfo.HubZoneId
    this.zone_obj.hubzonename = this.hubinfo.hubzonename
    this.hubzone = this.hubinfo.HubZoneId
    this.hubname = this.hubinfo.HubID
    let isLostNewFeatures = await this.getDataFromRedisbyKeyNameCommonFun({
      "key": "newLostDebitUserRestrictionHubLevelConfig"
    })
    console.log('isLostNewFeatures --------->>', isLostNewFeatures);
    this.isLostNewFeaturesisOnThisHub = isLostNewFeatures.includes(0) || isLostNewFeatures.includes(this.hubinfo.HubID) ? true : false;
    console.log('this.isLostNewFeaturesisOnThisHub -asd------->>', this.isLostNewFeaturesisOnThisHub);
    // let single_multiselect= document.getElementsByClassName('multiselect__single');
    // console.log("hshhshs", single_multiselect);
    // single_multiselect[0].innerHTML="--select client--";

  },
  methods: {
    handleEvent(){
      let single_multiselect= document.getElementsByClassName('multiselect__single');
      console.log("hshhshs", single_multiselect);
      if(single_multiselect[0].innerHTML==""){
        single_multiselect[0].innerHTML="--select client--";
      }

    },
    redirectToEditDebit(shipmentdata) {
      let shippingIds = JSON.stringify([shipmentdata.ShippingID]);
      this.$router.push({
        name: 'Hub Mark PickupLoss Debit',
        path: '/HubMarkPickupLossDebit',
        query: { id: shippingIds },
      });
    },

    getclientsObj(obj) {
      this.clientItemObj = obj
      this.clientid = obj.value
    },
    //to get Client list
    getClientData() {
      //  console.log('apiUrl.api_url',apiUrl.api_url);
      this.srLoader = this.loader;
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.clientArrayList = response.data.data;
            for (let i = 0; i < this.clientArrayList.length; i++) {
              this.clientList.push({
                value: this.clientArrayList[i].ClientMasterID,
                text: `${this.clientArrayList[i].CompanyName}`
              })
            }
          }
          else {
            this.clientList = [];
          }
          this.srLoader = "";
        })
        .catch((httpException) => {
          this.$alertify.error("client data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getHubListByZone(event) {
      axios.get(apiUrl.api_url + `external/getzonewisehublist?zoneid=` + event.target.value, {})
        .then((response) => {

          if (response.data.code === 200) {

            this.hubServiceCenterList = response.data.data;
            this.hubServiceCenterList.sort(function (a, b) {
              var nameA = a.HubName.toLowerCase(), nameB = b.HubName.toLowerCase()
              if (nameA < nameB) //sort string ascending
                return -1
              if (nameA > nameB)
                return 1
              return 0 //default return value (no sorting)
            });
          }
          else {
            this.hubServiceCenterList = [];
          }
        })
        .catch((httpException) => {
          //this.$alertify.error("Hub data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubZoneList = response.data.data;
          }
          else {
            this.hubZoneList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("hubzone data not found");
          console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.hubServiceCenterList = response.data.data;
          }
          else {
            this.hubServiceCenterList = [];
          }
        })
        .catch((httpException) => {
          this.$alertify.error("Hub data not found");
          console.error('exception is:::::::::', httpException)
        })

    },

    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.searchLostShipmentData();
    },
    searchData() {
      this.pageno = 1
      this.$refs.paginate.selected = 0;
      this.validateDateFields();
      if (this.dateError) {
        return; // block submission
      }
      this.searchLostShipmentData();
    },

    //search Raise Debit data
    searchLostShipmentData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.hubname != 0) {
            let payload = {};
            this.isSearchLoading = true;
            if (this.awbnumbers.length > 0) {
              let shippingIds = this.awbnumbers.split(/[\s,]+/).filter(shipmentId => shipmentId.trim() !== '');
              payload.ShippingId = shippingIds;
            }
            if (this.Vertical != 0) payload.Vertical = this.Vertical;
            if (this.clientid != 0) payload.ClientID = this.clientid;
            if (this.listtype != 0) payload.ListType = this.listtype;
            if (this.hubzone != 0) payload.CurrentHubZoneID = this.hubzone;
            if (this.hubname != 0) payload.CurrentHubId = this.hubname;
            if (this.notifystatus != 0) payload.NotifyStatus = this.notifystatus;
            if (this.amount != 0) payload.Amount = this.amount + '/' + this.amountcomparator + '/' + this.netpaymnet;
            if (this.gapdays != 0) payload.GapDays = this.gapdays + '/' + this.gapdayscomparator + '/' + this.txtgapdays;
            if (this.fromDate != null) payload.fromDate = this.fromDate;
            if (this.toDate != null) payload.toDate = this.toDate;
            if (this.source != 0) payload.source = this.source;
            payload.pageNo = this.pageno;
            payload.pageSize = 50;
            //console.log(payload);4
            axios.post(apiUrl.api_url + 'NoInfoShipments/list', payload)
            // axios.post('http://localhost:3800/NoInfoShipments/list', payload)
              .then((response) => {
                if (response.data.code == 200) {
                  let shipmentListData = response.data.data.rows;
                  //  console.log(shipmentListData);
                  let temparr = [];
                  let temparrCSV = [];
                  if (shipmentListData != null) {
                    response.data.data.rows.forEach((shipment) => {
                      shipment.NetPayment = shipment.NetPayment != null ? shipment.NetPayment : "0.00"
                      shipment.OctroiMRP = shipment.OctroiMRP != null ? shipment.OctroiMRP : "0.00"
                      var newcreateddate = this.changeDateFormat(shipment.CreatedDate);
                      var checkboxval = shipment.ShippingID + '_' + shipment.ClientID + '_' + shipment.CurrentHubId + '_' + shipment.NetPayment + '_' + shipment.OctroiMRP
                      shipment.CreatedDate = newcreateddate;
                      shipment.checkboxval = checkboxval.toString();
                      temparrCSV.push({
                        "ClientName": shipment.ClientName,
                        "ShippingID": shipment.ShippingID,
                        // "NetPayment": shipment.NetPayment,
                        // "OctroiMRP": shipment.OctroiMRP,
                        "NotifyStatus": shipment.NotifyStatus,
                        "Status": shipment.Status,
                        "ShipmentStatus": shipment.ShipmentStatus,
                        "CurrentHubName": shipment.CurrentHubName,
                        "OriginHubName": shipment.OriginHubName,
                        "FinalDestinationName": shipment.FinalDestinationName,
                        "NotifyGapDays": shipment.NotifyGapDays,
                        "ShipmentGapDays": shipment.ShipmentGapDays,
                        "CreatedDate": newcreateddate,
                        "CreatedBy": shipment.CreatedBy,
                      });
                    });
                  }
                  this.shipmentList = response.data.data.rows;
                  this.shipmentListCSV = temparrCSV;

                  let totalRows = response.data.TotalCount;
                  this.totalRecords = response.data.TotalCount
                  this.isShowing = true;
                  if (totalRows < 50) {
                    this.pagecount = 1
                  } else {
                    this.pagecount = Math.ceil(totalRows / 50)
                  }
                } else {
                  this.totalRecords = 0
                  this.pagecount = 1
                  this.shipmentList = [];
                  this.$alertify.error("No Records Found!");
                }
                this.isSearchLoading = false;
                //console.log('shipmentList',this.shipmentList);
              })
              .catch((httpException) => {
                this.$alertify.error("No Records Found!");
                console.error('exception is:::::::::', httpException)
                this.isSearchLoading = false;
              });
          }
        }
      }).catch(() => {
        this.isSearchLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    onSubmit: function (event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchRaiseDebitData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async exportForm() {
      if (this.shipmentListCSV == undefined || this.shipmentListCSV.length == 0) {
        this.$alertify.alert("No data", "No data available for download.");
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          let payload = {};
          this.isSearchLoading = true;
          if (this.clientid != 0) payload.ClientID = this.clientid;
          if (this.listtype != 0) payload.ListType = this.listtype;
          if (this.hubzone != 0) payload.CurrentHubZoneID = this.hubzone;
          if (this.hubname != 0) payload.CurrentHubId = this.hubname;
          if (this.notifystatus != 0) payload.NotifyStatus = this.notifystatus;
          if (this.amount != 0) payload.Amount = this.amount + '/' + this.amountcomparator + '/' + this.netpaymnet;
          if (this.gapdays != 0) payload.GapDays = this.gapdays + '/' + this.gapdayscomparator + '/' + this.txtgapdays;
          if (this.fromDate != null) payload.fromDate = this.fromDate;
          if (this.toDate != null) payload.toDate = this.toDate;
          if (this.source != 0) payload.source = this.source;
          payload.pageNo = this.pageno;
          payload.pageSize = 10;
          payload.exportFlag = "1"
          axios.post(apiUrl.api_url + 'NoInfoShipments/list', payload)
          // axios.post('http://localhost:3800/NoInfoShipments/list', payload)
            .then((response) => {
              if (response.data.code == 200) {
                let shipmentListData = response.data.data.rows;
                let temparrCSV = [];
                if (shipmentListData != null) {
                  response.data.data.rows.forEach((shipment) => {
                    var newcreateddate = this.changeDateFormat(shipment.CreatedDate);
                    var checkboxval = shipment.ShippingID + '_' + shipment.ClientID + '_' + shipment.CurrentHubId
                    shipment.CreatedDate = newcreateddate;
                    shipment.checkboxval = checkboxval.toString();
                    temparrCSV.push({
                      "ClientName": shipment.ClientName,
                      "ShippingID": shipment.ShippingID,
                      // "NetPayment": shipment.NetPayment,
                      // "OctroiMRP": shipment.OctroiMRP,
                      "NotifyStatus": shipment.NotifyStatus,
                      "Status": shipment.Status,
                      "ShipmentStatus": shipment.ShipmentStatus,
                      "CurrentHubName": shipment.CurrentHubName,
                      "OriginHubName": shipment.OriginHubName,
                      "FinalDestinationName": shipment.FinalDestinationName,
                      "NotifyGapDays": shipment.NotifyGapDays,
                      "ShipmentGapDays": shipment.ShipmentGapDays,
                      "CreatedDate": newcreateddate,
                      "CreatedBy": shipment.CreatedBy,
                    });
                  });
                }
                this.shipmentListCSV = temparrCSV;
                this.getDownloadCsvObject(this.shipmentListCSV);

              } else {
                this.shipmentList = [];
                this.$alertify.error("No Records Found!");
              }
              this.isSearchLoading = false;
              this.getDownloadCsvObject(this.shipmentListCSV);
              //console.log('shipmentList',this.shipmentList);
            })
            .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
              this.isSearchLoading = false;
            });
        }
      }).catch(() => {
        this.isSearchLoading = false;
        console.log('errors exist', this.errors)
      });
      //await this.searchLostShipmentData()

    },
    changeDateFormat(inputString) {
      let current_datetime = new Date(inputString)
      let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
      return formatted_date;
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "Pickuploss_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
    },
    resetForm() {
      this.Vertical = '';
      this.awbnumbers = []
      this.clientid = 0;
      this.clientItemObj = {}
      this.listtype = ''
      // this.hubzone = 0;
      // this.hubname = 0;
      this.amount = 0;
      this.amountcomparator = 0;
      this.netpaymnet = '';
      this.gapdays = 0;
      this.txtgapdays = '';
      this.gapdayscomparator = 0;
      this.pageno = 1;
      this.$refs.paginate.selected = 0;
      this.isShowing = false;
      this.$validator.reset();
      this.errors.clear();
      this.defaultHhub.hubID = this.hubinfo.HubID
      this.defaultHhub.HubName = this.hubinfo.HubName
      this.zone_obj.hubzoneid = this.hubinfo.HubZoneId
      this.zone_obj.hubzonename = this.hubinfo.hubzonename
      this.hubname = this.hubinfo.HubID
      this.hubzone = this.hubinfo.HubZoneId
      this.fromDate =  null
      this.toDate = null
      this.dateError = ""
      this.source = ''
    },
    format_number(e) {
      if (e > this.validation.max) {
        return this.validation.max
      } else if (e < this.validation.min) {
        return this.validation.min
      } else if (Math.round(e * this.validation.decimal) / this.validation.decimal != e) {
        return this.last_value
      } else {
        this.last_value = e
        return e
      }
    },
    validateDateFields() {
      this.dateError = "";

      // Case 1: If one date selected but not the other
      if ((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)) {
        this.dateError = "Both From Date and To Date must be selected.";
        return;
      }

      // Case 2: If both selected, enforce 1-day gap
      if (this.fromDate && this.toDate) {
        const start = new Date(this.fromDate);
        const end = new Date(this.toDate);

        if (end < start) {
          this.dateError = "To Date cannot be earlier than From Date.";
          return;
        }
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/pickuploss/Pickuploss.component.js